export enum Alignment{
    Left,
    Right,
    HorizontalCenter,
    VerticalCenter,
    Top,
    Bottom
}